export const botAdditionalInfo = {
    en: {
        tabFirst: "Bot Configuration",
        tabSecond: "Open Positions",
        tabThird: "Closed Positions",
        stopLossPercentage: "Stop Loss Percentage:",
        tpPercentage: "Take Profit Percentage:",
        leverageRate: "Leverage:",
        overallProfit: "Profit Percentage:",
        overallProfitAmount: "Profit:",
        openPositionNumber: "Open Positions:",
        closedPositionNumber: "Closed Positions:",
        walletEnd: "Balance Amount:",
        walletStart: "Started Balance:",
        noOpenPosition: "There are no active open order currently.",
        yesOpenPosition: "Active position(s)",
        noClosedPosition: "There are no closed order currently.",
        yesClosedPosition: "Closed position(s)",
        closePosition: "Close position",
    },
    tr: {
        tabFirst: "Bot Ayarları",
        tabSecond: "Açık Pozisyonlar",
        tabThird: "Kapatılmış Pozisyonlar",
        stopLossPercentage: "Stop Loss Yüzdesi:",
        tpPercentage: "Kar Alma Yüzdesi:",
        overallProfitAmount: "Kar:",
        leverageRate: "Kaldıraç:",
        overallProfit: "Kar Yüzdesi:",
        openPositionNumber: "Açık Pozisyon sayısı:",
        closedPositionNumber: "Kapalı Pozisyon Sayısı:",
        walletEnd: "Mevcut miktar:",
        walletStart: "Başlangıç miktarı:",
        noOpenPosition: "Mevcut durumda açık bir emir bulunmamaktadır.",
        noClosedPosition: "Mevcut durumda kapanmış bir emir bulunmamaktadır.",
        yesOpenPosition: "Açık pozisyon(lar)",
        yesClosedPosition: "Kapanmış pozisyon(lar)",
        closePosition: "Posizyonu kapat",
    },
};
